
import React from 'react';

function AvailabilityTable({ availability }) {
  let parsed = {};
  if (typeof availability === 'string') {
    try {
      parsed = JSON.parse(availability);
    } catch (e) {
      return <span style={{ color: '#888' }}>No availability set</span>;
    }
  } else if (typeof availability === 'object' && availability !== null) {
    parsed = availability;
  } else {
    return <span style={{ color: '#888' }}>No availability set</span>;
  }

  const days = [
    { key: 'mon', label: 'Mon' },
    { key: 'tue', label: 'Tue' },
    { key: 'wed', label: 'Wed' },
    { key: 'thu', label: 'Thu' },
    { key: 'fri', label: 'Fri' },
    { key: 'sat', label: 'Sat' },
    { key: 'sun', label: 'Sun' },
  ];

  return (
    <div style={{ fontFamily: 'inherit', fontSize: 15, lineHeight: 1.7, color: '#333', padding: '8px 0' }}>
      {days.map(day => (
        <div key={day.key}>
          <strong>{day.label}:</strong> {parsed[day.key] && parsed[day.key].length > 0
            ? parsed[day.key].join(', ')
            : <span style={{ color: '#bbb', fontStyle: 'italic' }}>—</span>}
        </div>
      ))}
    </div>
  );
}

export default AvailabilityTable;
